// Attaches the JWT from localStorage to every /api/* request, for both
// fetch and axios, and forces a re-login if the backend ever rejects it as
// missing/invalid/expired. Imported once for its side effects (see
// src/index.js) so no individual component needs to remember to send the
// Authorization header or handle a 401 itself.
import axios from 'axios';

function clearSessionAndRedirect() {
  if (window.location.pathname === '/login') return;

  localStorage.removeItem('userType');
  localStorage.removeItem('userName');
  localStorage.removeItem('token');
  window.location.href = '/login';
}

const originalFetch = window.fetch.bind(window);

window.fetch = (input, init = {}) => {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  const isApi = url.startsWith('/api/');
  const isLoginAttempt = url === '/api/login';

  if (isApi) {
    const token = localStorage.getItem('token');
    if (token) {
      init = {
        ...init,
        headers: {
          ...(init.headers || {}),
          Authorization: `Bearer ${token}`,
        },
      };
    }
  }

  return originalFetch(input, init).then((response) => {
    // A 401 on the login form itself just means "wrong password" — let the
    // form handle that. A 401 anywhere else means the token is missing/expired.
    if (response.status === 401 && isApi && !isLoginAttempt) {
      clearSessionAndRedirect();
    }
    return response;
  });
};

axios.interceptors.request.use((config) => {
  if (config.url && config.url.startsWith('/api/')) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.config?.url !== '/api/login') {
      clearSessionAndRedirect();
    }
    return Promise.reject(error);
  }
);
